import { render } from "./BestShadowTeam.vue?vue&type=template&id=5e57252e"
import script from "./BestShadowTeam.vue?vue&type=script&lang=js"
export * from "./BestShadowTeam.vue?vue&type=script&lang=js"

import "./BestShadowTeam.vue?vue&type=style&index=0&id=5e57252e&lang=css"

import exportComponent from "/home/misha/Рабочий стол/sportkit-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__